import React from 'react';

const WelcomeScreen = ({ onStartClick }) => {
  return (
    <div className="h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 flex flex-col items-center px-4 sm:px-8 py-[1vh] overflow-hidden">
      {/* Jeep Nation Logo - Responsive height based on viewport */}
      <div className="flex-shrink-0 py-[1vh]">
        <img
          src="/jeep-logo-color.png"
          alt="Jeep Nation"
          className="h-[8vh] sm:h-[10vh] md:h-[12vh] max-h-40 w-auto drop-shadow-2xl"
        />
      </div>

      {/* Main Content - Positioned higher for better touchscreen accessibility */}
      <div className="flex-1 flex flex-col justify-start items-center text-center w-full max-w-2xl min-h-0 pt-[8vh] sm:pt-[12vh] md:pt-[15vh]">
        {/* Main Headline - Responsive text and spacing */}
        <div className="space-y-1 sm:space-y-2 mb-[3vh] sm:mb-[5vh] md:mb-[6vh]">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white uppercase tracking-wide">
            Capture
          </h2>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white uppercase tracking-wide">
            The Moment
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-200 mt-2 sm:mt-3 md:mt-4">
            Transform your photos with AI technology
          </p>
        </div>

        {/* Start Button - Positioned at center height for easy access */}
        <button
          onClick={onStartClick}
          className="group relative px-12 sm:px-16 md:px-20 py-4 sm:py-5 md:py-6 bg-jeep-red text-white text-xl sm:text-2xl md:text-3xl font-bold rounded-full shadow-2xl hover:shadow-jeep-red/50 transform hover:scale-105 active:scale-95 transition-all duration-300 uppercase tracking-wide flex items-center gap-2 sm:gap-3 hover:bg-jeep-red-dark"
        >
          <span className="relative z-10">Start Now</span>
          <span className="text-xl sm:text-2xl md:text-3xl">→</span>
        </button>
      </div>

      {/* Bottom spacing */}
      <div className="flex-shrink-0 py-[1vh]"></div>
    </div>
  );
};

export default WelcomeScreen;
